import * as Yup from 'yup'

import { AccountType } from 'src/types/account'

export const accountTypeValidationSchema = (accountTypeKey: string) => ({
  Sector: Yup.mixed().when(accountTypeKey, {
    is: AccountType.FarmingForestryRural,
    then: Yup.string().required(
      'Please tell us which sector your farming / rural / forestry group primarily works in'
    )
  }),
  BusinessType: Yup.mixed().when(accountTypeKey, {
    is: AccountType.Business,
    then: Yup.string().required(
      'Please tell us what kind of work your business primarily engages in'
    )
  }),
  SchoolType: Yup.mixed().when(accountTypeKey, {
    is: AccountType.SchoolTertiary,
    then: Yup.string().required(
      'Please tell us what kind of school / tertiary institute you are'
    )
  }),
  OrgType: Yup.mixed().when(accountTypeKey, {
    is: AccountType.Community,
    then: Yup.string().required(
      'Please tell us what kind of organisation you are'
    )
  }),
  GovType: Yup.mixed().when(accountTypeKey, {
    is: AccountType.Government,
    then: Yup.string().required(
      'Please tell us what kind of Government organisation you are'
    )
  }),
  FocusArea: Yup.string().when(accountTypeKey, {
    is: AccountType.Community,
    then: Yup.string().required('Please tell us your main focus area')
  })
})
